const initial = {
  listPage: {
    all() {
      return {
        filters: this.filters()
      }
    },
    filters() {
      return {
        type: '',
        largeImages: false,
        sortBy: '',
        currentPage: 1,
        maxItems: 10,
      }
    }
  }
}
const state = {
  pokemon: {
    list: [],
    types: [],
    typeEfficacy: [],
    listStats: [],
    listPage: initial.listPage.all()
  }
}

const mutations = {
  POKEMON_SET_SIMPLE_LIST(state, simpleList) {
    state.pokemon.list = simpleList
  },
  POKEMON_SET_TYPES(state, types) {
    state.pokemon.types = types
  },
  POKEMON_SET_TYPE_EFFICACY(state, typeEfficacy) {
    state.pokemon.typeEfficacy = typeEfficacy
  },
  POKEMON_SET_SIMPLE_STATS_LIST(state, simpleStatsList) {
    state.pokemon.listStats = simpleStatsList
  },
  LIST_PAGE_SET_ALL(state, all) {
    state.pokemon.listPage = all
  },
  LIST_PAGE_SET_MAX_ITEMS(state, maxItems) {
    state.pokemon.listPage.maxItems = maxItems
  },
  LIST_PAGE_SET_FILTER(state, filter) {
    state.pokemon.listPage.filters[filter.key] = filter.value
  },
  LIST_PAGE_SET_ALL_FILTERS(state, filters) {
    state.pokemon.listPage.filters = filters
  },
}

const actions = {
  setSimpleList: ({ commit }, simpleList) => commit('POKEMON_SET_SIMPLE_LIST', simpleList),
  setTypes: ({ commit }, types) => commit('POKEMON_SET_TYPES', types),
  setTypeEfficacy: ({ commit }, typeEfficacy) => commit('POKEMON_SET_TYPE_EFFICACY', typeEfficacy),
  setSimpleStatsList: ({ commit }, simpleStatsList) => commit('POKEMON_SET_SIMPLE_STATS_LIST', simpleStatsList),
  listPageSetAll: ({ commit }, all) => commit('LIST_PAGE_SET_ALL', all),
  listPageSetMaxItems: ({ commit }, maxItems) => commit('LIST_PAGE_SET_MAX_ITEMS', maxItems),
  listPageSetFilter: ({ commit }, filter) => commit('LIST_PAGE_SET_FILTER', filter),
  listPageSetAllFilters: ({ commit }, filters) => commit('LIST_PAGE_SET_ALL_FILTERS', filters),
}

const getters = {
  list: state => state.pokemon.list,
  types: state => state.pokemon.types,
  typeEfficacy: state => state.pokemon.typeEfficacy,
  listStats: state => state.pokemon.listStats,
  listPage: state => state.pokemon.listPage,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
